import BigNumber from "bignumber.js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime"; // 相对时间
import moment from "moment";
import VueCookies from "vue-cookies";
dayjs.extend(relativeTime);
export default {
  // js数字加法
  getBigNumber(value) {
    return BigNumber(value);
  },
  // 获取每月天数
  curDate: new Date(),
  nowMonth: new Date().getMonth(),
  nowYear: new Date().getFullYear(),
  getMonthtDays() {
    let monthStartDate = new Date(this.nowYear, this.nowMonth, 1);
    let monthEndDate = new Date(this.nowYear, this.nowMonth + 1, 1);
    let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
  },
  // 格式化日期：yyyy-MM-dd
  formatDate(date) {
    let myyear = date.getFullYear();
    let mymonth = date.getMonth() + 1;
    var myweekday = date.getDate();
    if (mymonth < 10) {
      mymonth = 0 + mymonth;
    }
    if (myweekday < 10) {
      myweekday = 0 + myweekday;
    }
    return myyear + "-" + mymonth + "-" + myweekday;
  },
  // 获取本季度开始年月份
  getQuarterStartMonth() {
    let quarterStartMonth = 0;
    if (this.nowMonth < 3) {
      quarterStartMonth = 0;
    }
    if (this.nowMonth > 2 && this.nowMonth < 6) {
      quarterStartMonth = 3;
    }
    if (this.nowMonth > 5 && this.nowMonth < 9) {
      quarterStartMonth = 6;
    }
    if (this.nowMonth > 8) {
      quarterStartMonth = 9;
    }
    return quarterStartMonth;
  },
  // 获得本季度的开始日期
  getQuarterStartDate() {
    let quarterStartDate = new Date(
      this.nowYear,
      this.getQuarterStartMonth(),
      1
    );
    return this.formatDate(quarterStartDate) + " " + "00:00:00";
  },
  // 获得本季度的结束日期
  getQuarterEndDate() {
    let quarterEndDate = new Date(
      this.nowYear,
      this.getQuarterStartMonth() + 2,
      this.getMonthtDays(this.getQuarterStartMonth() + 2)
    );
    return this.formatDate(quarterEndDate) + " " + "23:59:59";
  },
  // 获得上季度的开始日期
  getUpperQuarterStartDate() {
    let quarterStartDate;
    if (this.getQuarterStartMonth() < 3) {
      quarterStartDate = new Date(this.nowYear - 1, 9, 1);
    } else {
      quarterStartDate = new Date(
        this.nowYear,
        this.getQuarterStartMonth() - 3,
        1
      );
    }
    return this.formatDate(quarterStartDate) + " " + "00:00:00";
  },
  /**
   * 计算两个日期之间的天数
   * @param {string} Date_end 结束日期
   * @param {string} Date_start 开始日期
   * @return {number} iDays间隔的天数
   */
  DateDiff(Date_end, Date_start) {
    let aDate, oDate1, oDate2, iDays;
    Date_end = Date_end.split(" "); //将时间以空格划分为两个数组  第一个数组是 2019-05-20 第二个数组是 00：00：00
    aDate = Date_end[0].split("-"); //获取第一个数组的值
    oDate1 = new Date(aDate[0], aDate[1], aDate[2]); //将前半个数组以-拆分，每一个是一个数值
    Date_start = Date_start.split(" ");
    aDate = Date_start[0].split("-");
    oDate2 = new Date(aDate[0], aDate[1], aDate[2]);
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
    return iDays;
  },
  /**
   * 返回指定单位下两个日期时间之间的差异
   * @param {*} startTime
   * @param {*} endTime
   * @param {*} type 差异的类型： type: '' | 'day' | 'hour' | 'minute'
   * @returns number 默认返回毫秒数
   */
  getTimeDiff(startTime, endTime, type) {
    let start = dayjs(startTime);
    let end = dayjs(endTime);
    if (type) {
      return Math.abs(start.diff(end, type));
    } else {
      return Math.abs(start.diff(end));
    }
  },
  // 获得上季度的结束日期
  getUpperQuarterEndDate() {
    let quarterEndDate;
    if (this.getQuarterStartMonth() < 3) {
      quarterEndDate = new Date(this.nowYear - 1, 11, this.getMonthtDays(12));
    } else {
      quarterEndDate = new Date(
        this.nowYear,
        this.getQuarterStartMonth() - 1,
        this.getMonthtDays(this.getQuarterStartMonth() - 3)
      );
    }
    return this.formatDate(quarterEndDate) + " " + "23:59:59";
  },
  formatTimeStamp(timeStamp, format) {
    if (!format) {
      format = "YYYY-MM-DD HH:mm";
    }
    return moment.unix(moment(timeStamp).unix()).format(format);
  },
  formatTimeStampSecond(timeStamp, format) {
    if (!format) {
      format = "YYYY-MM-DD HH:mm:ss";
    }
    return moment.unix(moment(timeStamp).unix()).format(format);
  },
  checkMobile(mobile) {
    let mobileReg = /^1\d{10}$/;
    if (!mobile) {
      return false;
    }
    if (mobileReg.test(mobile)) {
      return true;
    } else {
      return false;
    }
  },
  checkEmail(email) {
    let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    if (!email) {
      return false;
    }
    if (emailReg.test(email)) {
      return true;
    } else {
      return false;
    }
  },
  checkPwd(password) {
    let pwdReg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/;
    if (!password) {
      return false;
    }
    if (pwdReg.test(password)) {
      return true;
    } else {
      return false;
    }
  },
  checkNumber(number) {
    let numberReg = /^[1-9]\d*$/;
    if (!number) {
      return false;
    }
    if (numberReg.test(number)) {
      return true;
    } else {
      return false;
    }
  },
  debounce(fn, wait) {
    let timer = null;
    return function() {
      let context = this;
      let args = arguments;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  },
  getStorage(key) {
    let v = localStorage.getItem(key);
    if (!v) {
      let base64 = VueCookies.get(key);
      // console.log('cookie key=' + key + ', value=' + base64)
      if (base64) {
        v = atob(base64);
        localStorage.setItem(key, v);
      }
    }
    return v;
  },
  setStorage(key, value) {
    localStorage.setItem(key, value);
    VueCookies.set(key, btoa(value)); // 有些浏览器不支持跨站localStorage，所以需要同时写cookie
  },
  removeStorage(key) {
    // localStorage.setItem(key, '')
    localStorage.removeItem(key);
    VueCookies.remove(key);
    // VueCookies.set(key, undefined)
  },
  urlAppendParam(url, key, value) {
    if (url.indexOf("?") > 0) {
      url = url + "$" + key + "=" + new Date().getTime();
    } else {
      url = url + "?" + key + "=" + new Date().getTime();
    }
    return url;
  },
  numberFixed(number, digit) {
    return number
      .toFixed(digit)
      .replace(/0+$/g, "")
      .replace(/(\.*$)/g, "");
  },
  canvas() {
    var canvas = document.getElementById("canvas"); // 获取id
    var ctx = canvas.getContext("2d"); // 对象动画2d
    var opt = {
      particleAmount: 50, // 粒子个数
      defaultSpeed: 1, // 粒子运动速度
      variantSpeed: 1, // 粒子运动速度的变量
      particleColor: "rgb(208 216 241)", // 粒子的颜色
      lineColor: "rgb(208 216 241)", // 网格连线的颜色
      defaultRadius: 3, // 粒子半径
      variantRadius: 3, // 粒子半径的变量
      minDistance: 200 // 粒子之间连线的最小距离
    };
    var line = opt.lineColor.match(/\d+/g);
    console.log(line);
    var particle = [],
      w,
      h;
    var delay = 200,
      tid;
    init();
    window.addEventListener(
      "resize",
      function() {
        winResize();
      },
      false
    );

    function winResize() {
      clearTimeout(tid);
      tid = setTimeout(function() {
        getSize();
      }, delay);
    }

    function init() {
      getSize();
      for (let i = 0; i < opt.particleAmount; i++) {
        particle.push(new Partical());
      }
      loop();
    }

    function loop() {
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < particle.length; i++) {
        particle[i].update();
        particle[i].draw();
      }
      for (let i = 0; i < particle.length; i++) {
        linePoint(particle[i], particle);
      }
      window.requestAnimationFrame(loop);
    }

    function linePoint(point, hub) {
      for (let i = 0; i < hub.length; i++) {
        let distance = getDistance(point, hub[i]);
        let opacity = 1 - distance / opt.minDistance;
        if (opacity > 0) {
          ctx.lineWidth = 0.5;
          ctx.strokeStyle =
            "rgba(" +
            line[0] +
            "," +
            line[1] +
            "," +
            line[2] +
            "," +
            opacity +
            ")";
          ctx.beginPath();
          ctx.moveTo(point.x, point.y);
          ctx.lineTo(hub[i].x, hub[i].y);
          ctx.closePath();
          ctx.stroke();
        }
      }
    }

    function getDistance(point1, point2) {
      return Math.sqrt(
        Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)
      );
    }

    function getSize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    }
    function Partical() {
      this.x = Math.random() * w; // 粒子的x轴坐标
      this.y = Math.random() * h; // 粒子的y轴坐标
      this.speed = opt.defaultSpeed + opt.variantSpeed * Math.random(); // 粒子的运动速度
      this.directionAngle = Math.floor(Math.random() * 360); // 粒子运动的方向
      this.color = opt.particleColor; // 粒子的颜色
      this.radius = opt.defaultRadius + Math.random() * opt.variantRadius; // 粒子的半径大小
      this.vector = {
        x: this.speed * Math.cos(this.directionAngle), // 粒子在x轴的速度
        y: this.speed * Math.sin(this.directionAngle) // 粒子在y轴的速度
      };
      this.update = function() {
        // 粒子的更新函数
        this.border(); // 判断粒子是否到了边界
        this.x += this.vector.x; // 粒子下一时刻在x轴的坐标
        this.y += this.vector.y; // 粒子下一时刻在y轴的坐标
      };
      this.border = function() {
        // 判断粒子是都到达边界
        if (this.x >= w || this.x <= 0) {
          // 如果到达左右边界，就让x轴的速度变为原来的负数
          this.vector.x *= -1;
        }
        if (this.y >= h || this.y <= 0) {
          // 如果到达上下边界，就让y轴的速度变为原来的负数
          this.vector.y *= -1;
        }
        if (this.x > w) {
          // 下面是改变浏览器窗口大小时的操作，改变窗口大小后有的粒子会被隐藏，让他显示出来即可
          this.x = w;
        }
        if (this.y > h) {
          this.y = h;
        }
        if (this.x < 0) {
          this.x = 0;
        }
        if (this.y < 0) {
          this.y = 0;
        }
      };
      this.draw = function() {
        // 绘制粒子的函数
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fillStyle = this.color;
        ctx.fill();
      };
    }
  },
  exportFileUtilsExcel(url, name, query, type, mediaType) {
    return new Promise((resolve, reject) => {
      if (query) {
        let queryString = "";
        for (let field in query) {
          let value = query[field];
          if (value && value.toString() !== "") {
            queryString += "&" + field + "=" + value;
          }
        }
        if (queryString) {
          url += "?" + queryString.substring(1);
        }
      }

      let xmlResquest = new XMLHttpRequest();
      let timestamp = new Date().getTime();
      xmlResquest.open(type || "get", url, true);
      xmlResquest.setRequestHeader(
        "Content-type",
        mediaType ? mediaType : "application/x-www-form-urlencoded"
      );
      xmlResquest.setRequestHeader("token", localStorage.getItem("token"));
      xmlResquest.responseType = "blob";
      xmlResquest.onload = function(oEvent) {
        let content = xmlResquest.response;
        let elink = document.createElement("a");
        if (query && query.startTime) {
          elink.download = name + ".xlsx";
        } else {
          elink.download = name + ".xlsx";
        }
        elink.style.display = "none";
        let blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        resolve();
      };
      xmlResquest.onerror = function(error) {
        reject(error);
      };
      // xmlResquest.send();
      // 将 body 转换为 JSON 字符串并发送
      xmlResquest.send(JSON.stringify(query));
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js